import { FrequencyValue } from "./FrequencyValue";
import type { IntensityRef } from "../App";
import { SpectrumMeter } from "./SpectrumMeter";
interface DebugPanelProps {
  getFrequencyData: () => Float32Array;
  sampleRate: number; fftSize: number; minFreq: number; maxFreq: number; threshold: number;
  onThresholdChange: (value: number) => void;
  onMinFreqChange: (value: number) => void;
  onMaxFreqChange: (value: number) => void;
  intensityRef: React.RefObject<IntensityRef>;
}
export function DebugPanel(props: DebugPanelProps) {
  return <section className="instrument-section frequency-section" aria-labelledby="bass-heading">
    <h2 id="bass-heading" className="instrument-heading">低频 / KICK</h2>
    <div className="frequency-endpoints">
      <FrequencyValue label="低频下限" value={props.minFreq} min={10} max={Math.min(200, props.maxFreq - 1)}
        step={1} unit="Hz" onChange={props.onMinFreqChange} />
      <FrequencyValue label="低频上限" value={props.maxFreq} min={Math.max(20, props.minFreq + 1)} max={300}
        step={1} unit="Hz" onChange={props.onMaxFreqChange} />
    </div>
    <SpectrumMeter {...props} label="低频" />
    <div className="threshold-control">
      <label htmlFor="kick-threshold">Threshold <span>{props.threshold.toFixed(2)}</span></label>
      <input id="kick-threshold" aria-label="Kick 触发阈值" type="range" min={0} max={1} step={0.01}
        value={props.threshold} onChange={event => props.onThresholdChange(event.currentTarget.valueAsNumber)} />
    </div>
  </section>;
}
